import { StyleSheet } from "react-native"
import { baseColors, baseFontFamily, basePadding } from "@Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: baseColors.white
    },
    content: {
        paddingHorizontal: basePadding.paddingHorizontal,
        paddingVertical: basePadding.paddingVertical
    },
    header: {
        marginBottom: 25
    },
    headerTile: {
        color: baseColors.green.primary,
        marginBottom: 12
    },
    item: {
        backgroundColor: baseColors.green.light,
        borderRadius: 10,
        marginBottom: 18
    },
    title: {
        fontSize: RFValue(16),
        fontFamily: baseFontFamily.OpenSansSemiBold,
        color: baseColors.black
    }
})

export default styles
